import {__} from "./__";

export const getAiAgentDays = () => {
    return {
        1: __('Pondelok'),
        2: __('Utorok'),
        3: __('Streda'),
        4: __('Štvrtok'),
        5: __('Piatok'),
        6: __('Sobota'),
        7: __('Nedeľa'),
    };
};
